import { _decorator } from 'cc';
import { DEV } from 'cc/env';
import ITweenEffect from './ITweenEffect';

const { ccclass, property, menu } = _decorator;

@ccclass('RotateTweenEffect')
@menu('TweenEffect/RotateTweenEffect')
export default class RotateTweenEffect extends ITweenEffect<number> {
    @property({ displayName: DEV && '起始角度' })
    protected readonly from: number = 0;

    @property({ displayName: DEV && '目標角度' })
    protected readonly end: number = 360;

    protected get target() {
        return this.node;
    }
    protected buildParam(value: number) {
        return { angle: value };
    }
}
